<template>
  <div class="wrapper" :style="styles">
    <div class="widget">
      <div class="whead ">
        <slot name="head">
          <h6><Icon :type="icon" />{{ title }}</h6>
        </slot>
        <slot name="toolbar">
          <div class="modify-record">
            <a href="#" @click="showModifyRecords" v-if="isModify===true">
              修改痕迹
            </a>
            <div class="edit-head-back" @click="paasPageBack">
              <Icon type="ios-close"  size="32" />
            </div>
          </div>
        </slot>
      </div>
      <div class="body" :style="contentStyle" v-height="{offsetHeight:offsetHeight}">
        <slot name="form"></slot>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "wrapper-edit",
      props:{
        wrapperWidth: {
          type: [Number,String]
        },
        offsetHeight:{
          type:[Number,String],
          default: function () {
            return 0 ||'0px'
          }
        },
        contentPadding:{
          type:[Number,String],
        },
        offsetWidth:{
          type:[Number,String],
        },
        isModify:{
          type:Boolean,
          default:false
        },
        wIcon:{
          type:String,
          default:''
        },
        wTitle:{
          type:String,
          default:''
        }
      },
      data(){
          return{
            func: {}, //功能
            title:this.wTitle,
            icon:this.wIcon,
          }
      },
      computed: {
        //这是为了计算form-wrap的宽度
        styles () {
          let style = {};
          if (this.wrapperWidth) {
            style['width'] = `${this.wrapperWidth}`;
          }
          return style;
        },
        //计算body内容的高度
        contentStyle:function (){
          let style = {};
          style.padding = this.contentPadding;
          if(this.offsetHeight){
            let docHeight = document.documentElement.clientHeight; //可见区域的高度
            let contentHeight = docHeight - this.offsetHeight;
            style.height = contentHeight + "px";
          }
          if(this.offsetWidth){
            let docWidth = document.documentElement.clientWidth; //可见区域的宽度
            let contentWidth = docWidth - this.offsetWidth;
            style.width = contentWidth + "px";
          }
          return style;
        }
      },
      created(){
        let funcId = this.$route.query.paasCurrentFunctionId;
        let funcOper = this.$store.state.funcOper;
        if(!funcOper && window.localStorage.getItem("opers")) {
          funcOper = JSON.stringify(window.localStorage.getItem("opers"));
        }
        if(funcOper){
          this.func = funcOper[funcId].func;
          if(this.isEmpty(this.wTitle)){
            this.title = this.func.name + "编辑页面";
          }
          if(this.isEmpty(this.wIcon)){
            this.icon = this.func.icon;
          }
          this.opers = funcOper[funcId].opers;
        }
      },
      methods:{
        //edit页面返回跳转方法
        paasPageBack(){
          this.$emit("back");
        },
        //edit修改记录显示方法
        showModifyRecords(){
          this.$emit("modify")
       },
        isEmpty(item){
          let flag = false;
          if(item === null || item === "" || item === "undefined" || item === undefined || item === "null"){
            flag = true;
          }
          return flag;
        }
      }
    }
</script>

<style scoped>
 @import "../../assets/css/meta-edit.css";
</style>
